import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Tooltip, Icon, Badge, Popover, Button } from 'antd';
import { withRouter } from 'react-router-dom';
import moment from 'moment-timezone';

@withRouter
@inject('store')
@observer
export class StatusPanel extends Component {
    renderSLCooldown() {
        const { config } = this.props.store.makoBotStore;
        const timezone = this.props.store.userStore.currentUser.timezone;

        if (Date.now() < config.stop_loss_active_cooldown) {
            return (
                <span>
                    <Tooltip
                        title={`Stoploss cooldown in effect: ${moment(
                            config.stop_loss_active_cooldown
                        )
                            .tz(timezone)
                            .format('DD/MM/YYYY hh:mm a')}`}
                    >
                        <Icon type="clock-circle" theme="outlined" className="not-connected" />
                    </Tooltip>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                </span>
            );
        }
        if (Date.now() < config.entry_active_cooldown) {
            return (
                <span>
                    <Tooltip
                        title={`Entry cooldown in effect: ${moment(config.entry_active_cooldown)
                            .tz(timezone)
                            .format('DD/MM/YYYY hh:mm a')}`}
                    >
                        <Icon type="clock-circle" theme="outlined" className="not-connected" />
                    </Tooltip>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                </span>
            );
        }
        return null;
    }

    render() {
        const { config, connected, exchangeConnected } = this.props.store.makoBotStore;

        const controlPanel = (
            <div style={{ width: 250 }}>
                <Button
                    style={{ marginBottom: 5 }}
                    block
                    type={config.enabled ? 'danger' : 'primary'}
                    onClick={() => {
                        const next = { ...config };
                        next.enabled = !(next.enabled || false);
                        this.props.store.makoBotStore.updateConfig(next);
                    }}
                >
                    {!config.enabled ? <span>Start</span> : 'Stop'}{' '}
                </Button>
            </div>
        );

        return (
            <div className="status-panel">
                <div className={'inner'}>
                    <Row gutter={24}>
                        <Col xs={24} sm={12}>
                            <div style={{ display: 'inline-block', marginRight: 10 }}>
                                <img
                                    height="32px"
                                    style={{ marginTop: 6, marginRight: 10 }}
                                    src={`/exchanges/bybit.png`}
                                    alt="bybit exchange logo"
                                />
                                <span style={{ fontSize: 16, position: 'relative', top: 4 }}>
                                    {config.name}
                                </span>
                            </div>
                        </Col>
                        <Col
                            xs={24}
                            sm={12}
                            className={'text-right'}
                            style={{ position: 'relative', top: 7 }}
                        >
                            {this.renderSLCooldown()}
                            <Tooltip title={'UI'}>
                                {connected ? (
                                    <Icon type="wifi" theme="outlined" className="connected" />
                                ) : (
                                    <Icon type="wifi" theme="outlined" className="not-connected" />
                                )}
                            </Tooltip>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Tooltip title={'Exchange'}>
                                {exchangeConnected ? (
                                    <Icon type="bank" theme="outlined" className="connected" />
                                ) : (
                                    <Icon type="bank" theme="outlined" className="not-connected" />
                                )}
                            </Tooltip>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <span className={'status-list'}>
                                <Badge
                                    status={config.enabled ? 'success' : 'error'}
                                    text="Running"
                                />
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Popover
                                placement="bottomRight"
                                content={controlPanel}
                                title="Control Panel"
                                trigger="click"
                            >
                                <Button size="small" type="primary" shape="circle" icon="setting" />
                            </Popover>
                        </Col>
                    </Row>
                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/MakoBot/StatusPanel.js